<template>
    <div class="page-content">
        <div class="section main-section">
            <h1>Frequently Asked Questions</h1>
            <p>We tried to answer some of the common questions of travellers using PlanIt</p>
        </div>

        <div class="section question"
            v-for="n in 6"
            v-bind:key="n"
            v-bind:id="'question' + n">
            <h4>Question?</h4>
            <p>A Pocket PC is a handheld computer, which features many of the same capabilities as a modern PC. These handy little devices allow individuals to retrieve and store e-mail messages, create a contact file, coordinate appointments, surf the internet, exchange text messages and more.</p>
        </div>

        <div class="section contact-us">
            <h2>Still got unanswered questions?</h2>
            <p>Contact us directly</p>

            <router-link v-bind:to="{ name: 'ContactUs' }" class="main-btn">Send a Message</router-link>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FAQ',
        beforeCreate: function() {
            let body = document.querySelector('body')
            body.dataset.page = 'faq'
        }
    }
</script>

<style scoped lang="scss">
    .section.question {
        margin-left: auto;
        margin-right: auto;
        padding: 0 15px;
        max-width: 940px + (15px * 2);

        @media all and (min-width: $breakpoint + 1) {
            margin-top: 30px;
            line-height: 30px;
            font-size: 20px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            line-height: 24px;
            font-size: 14px;
        }
    }


    .section h4 {
        margin: 0;
        text-transform: uppercase;
        color: $accent;
    }


    .section.contact-us {
        background: url('/assets/images/contact_bg.png') no-repeat center;
        background-size: cover;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 30px 15px;
        min-height: calc(100vw / 1440 * 607);
        color: #FFF;
    }

    .section.contact-us::before {
        content: "";
        background-color: rgba(#000, 0.21);
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
    }


    .section.contact-us > * {
        position: relative;
    }


    .section.contact-us p {
        margin-top: 15px;
        font-weight: $book;
        font-size: 20px;

        @media all and (max-width: $breakpoint) {
            margin-top: 7px;
            font-size: 16px;
        }
    }


    .main-btn {
        margin-top: 70px;
        padding: 0 26px;

        @media all and (max-width: 920px) {
            margin-top: 40px;
        }

        @media all and (max-width: $breakpoint) {
            margin-top: 20px;
            padding: 0 15px;
            min-width: unset;
            height: 40px;
            line-height: 40px;
            font-size: 12px;
        }
    }
</style>
